<script setup lang="ts">
import { useAppStore } from '@/stores/app.store.ts'
import { computed } from 'vue'
import SkeletonBase from '@/components/skeleton/SkeletonBase.vue'
import PhIcon from '@/components/PhIcon.vue'

const appStore = useAppStore()
const breadcrumbs = computed(() => appStore.breadcrumbs)
</script>

<template>
  <div
    v-if="!!breadcrumbs"
    class="px-4 py-1 bg-stone-100/50 dark:bg-stone-900/50 text-sm transition-colors duration-150"
  >
    <div
      class="flex px-2 py-1 bg-stone-100 dark:bg-stone-900 font-serif transition-colors duration-150 rounded-md"
    >
      <div class="self-center flex gap-2 mr-2">
        <ph-icon name="command" :size="18"></ph-icon>
        <ph-icon name="dot" :size="18"></ph-icon>
      </div>
      <div v-for="(breadcrumb, i) in breadcrumbs" :key="i" class="flex gap-2">
        <span
          class="block self-center capitalize cursor-pointer text-blue-500 hover:underline decoration-1 decoration-dashed underline-offset-2"
          >{{ breadcrumb.name }}</span
        >
        <ph-icon
          v-if="i < breadcrumbs.length - 1"
          name="dot"
          :size="18"
          class="self-center"
        ></ph-icon>
      </div>
    </div>
  </div>
  <div v-else class="h-4">
    <skeleton-base width="8" height="auto" rounded="lg" color="stone"></skeleton-base>
  </div>
</template>

<style scoped></style>
